import React from "react";
import "@css/pages/employer/DocumentsEmployers/courseCertifications.css";
import "@css/pages/employer/listeEmployer.css";
import IconesRecutement from "@image/icones/DocumentsEmployers/drapeau.svg";
import IconCalendar from "@image/icones/icon_Calendar_Edit.svg";
import { formatDateToMoment } from "@helpers/_functions";
import { ModalEditEndJob } from "./modals";
import { withTranslation } from "react-i18next";

class EndJob extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalEditFin: false,
      centered: true,
    };
  }
  toggleEditFin = () => {
    this.setState({
      modalEditFin: !this.state.modalEditFin,
    });
  };
  render() {
    return (
      <>
        {this.props.status === "Inactif Définitivement" ? (
          <div
            className={this.props.dispositiveClass + " items_content_course"}
          >
            <div className="head_content_course d-flex flex-justify-between flex-align-center">
              <span className="title_items_course no_white_space bold GreenThemeSelect">
                <img
                  alt="recurtement"
                  className="icones_recrutement GreenThemeSelect"
                  src={IconesRecutement}
                />
                {this.props.t("Fin d’emploi")}
              </span>
              <div>
                <span className="dates_recrutement medium GreenThemeSelect">
                  {this.props.dateEndEmploi
                    ? formatDateToMoment(this.props?.dateEndEmploi)
                    : ""}
                </span>
                <img
                  src={IconCalendar}
                  className="pointeur"
                  alt=""
                 // onClick={this.toggleEditFin}
                />
              </div>
            </div>
            <div className="liste_courses">
              <div className="panel_course">
                <span className="description_course GreenThemeSelect regular">
                  {this.props.endJobDescription?.split("\n").map((note) => {
                    return (
                      <div key={note}>
                        {note}
                        <br />
                      </div>
                    );
                  })}
                </span>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
            <ModalEditEndJob
              onClickClose={this.toggleEditFin}
              employeeId={this.props.employeeId}
              dateUpdate={this.props.dateEndEmploi}
              description={this.props.endJobDescription}
              isOpen={this.state.modalEditFin}
            />
      </>
    );
  }
}

export default withTranslation("pages.employés.parcours&Certifications")(EndJob);
